import { Injectable } from '@angular/core';
import { Event } from '../../../shared/models/events/event.model';
import { BaseService } from '../../../shared/services/base.service';
import { Observable, Subject, tap } from 'rxjs';
import { EventGuestAccreditation } from '../../../shared/models/events/guests/event-guest-accreditation.model';
import { EventParking } from '../../../shared/models/events/event-parking.model';
import { EventSpaceZone } from '../../../shared/models/events/guests/event-space-zone.model';
import { EventSpace } from '../../../shared/models/events/event-space.model';
import { EventGuestMailing } from '../../../shared/models/events/guests/event-guest-mailing.model';
import { Mailing } from '../../../shared/models/mailings/mailing.model';

@Injectable({
    providedIn: 'root'
})
export class EventsService extends BaseService<Event> {
    private baseUrl = '/api/events';
    private _event: Event | null = null;
    event$: Subject<Event> = new Subject<Event>();

    getEvent(id: number): Observable<Event> {
        return this.http.get<Event>(`${this.baseUrl}/${id}`).pipe(
            tap(event => {
                this._event = event;
                this.event$.next(this._event);
            })
        );
    }

    getAccreditations(eventId: number): Observable<EventGuestAccreditation[]> {
        return this.http.get<EventGuestAccreditation[]>(`${this.baseUrl}/${eventId}/accreditations`);
    }

    getParkings(eventId: number): Observable<EventParking[]> {
        return this.http.get<EventParking[]>(`${this.baseUrl}/${eventId}/parkings`);
    }

    getZones(eventId: number): Observable<EventSpaceZone[]> {
        return this.http.get<EventSpaceZone[]>(`${this.baseUrl}/${eventId}/zones`);
    }

    getSpaces(eventId: number): Observable<EventSpace[]> {
        return this.http.get<EventSpace[]>(`${this.baseUrl}/${eventId}/spaces`);
    }

    getMailings(eventId: number): Observable<Mailing[]> {
        return this.http.get<Mailing[]>(`${this.baseUrl}/${eventId}/mailings`);
    }
}